import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { completeTraining } from "./thunks/complete-training";
import { listTopics } from "./thunks/list-topics";
import { markTopic } from "./thunks/mark-topic";
import { unmarkTopic } from "./thunks/unmark-topic";

const name = "education";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listTopics.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listTopics.fulfilled, (state, action) => {
        state.topics = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listTopics.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(markTopic.fulfilled, (state, action) => {
        // Upsert the topic (re-marking refreshes its stamp).
        const rest = state.topics.filter((t) => t.topic !== action.payload.topic);
        state.topics = [...rest, action.payload];
      })
      .addCase(unmarkTopic.fulfilled, (state, action) => {
        state.topics = state.topics.filter((t) => t.topic !== action.payload);
      })
      .addCase(completeTraining.pending, (state) => {
        state.isCompleting = true;
        state.completeError = "";
      })
      .addCase(completeTraining.fulfilled, (state) => {
        state.isCompleting = false;
        state.isCompleted = true;
      })
      .addCase(completeTraining.rejected, (state, action) => {
        state.isCompleting = false;
        state.completeError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
